import React, { useEffect, useRef, useState } from 'react';
import { FaStoreSlash } from 'react-icons/fa';
import { useStoreStatus } from '../../context/StoreStatusContext';
import { formatKitchenReopenHint, KITCHEN_OFFLINE_TITLE } from '../../utils/storeStatus';
import './KitchenClosedBanner.css';

export default function KitchenClosedBanner() {
  const { isKitchenOpen, status } = useStoreStatus();
  const wrapRef = useRef(null);
  const [open, setOpen] = useState(false);

  const reopenHint = formatKitchenReopenHint(status);
  const message = status?.closureMessage || '';
  const hasDetails = Boolean(message || reopenHint);
  const subtitle = reopenHint || 'Ordering is paused for now';

  useEffect(() => {
    if (!open) return undefined;

    const onPointerDown = (event) => {
      if (!wrapRef.current?.contains(event.target)) setOpen(false);
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  useEffect(() => {
    if (isKitchenOpen) setOpen(false);
  }, [isKitchenOpen]);

  if (isKitchenOpen) return null;

  return (
    <div
      ref={wrapRef}
      className={`navbar-kitchen-badge-wrap${open ? ' navbar-kitchen-badge-wrap--open' : ''}`}
    >
      <button
        type="button"
        className="navbar-kitchen-badge"
        aria-label={[KITCHEN_OFFLINE_TITLE, message, reopenHint].filter(Boolean).join('. ')}
        aria-expanded={hasDetails ? open : undefined}
        aria-haspopup={hasDetails ? 'dialog' : undefined}
        onClick={() => {
          if (hasDetails) setOpen((value) => !value);
        }}
      >
        <span className="navbar-kitchen-badge__shine" aria-hidden />
        <span className="navbar-kitchen-badge__live" aria-hidden>
          <span className="navbar-kitchen-badge__ping" />
          <span className="navbar-kitchen-badge__ping navbar-kitchen-badge__ping--delayed" />
          <FaStoreSlash />
        </span>
        <span className="navbar-kitchen-badge__copy">
          <span className="navbar-kitchen-badge__title">Kitchen offline</span>
          <span className="navbar-kitchen-badge__meta">{subtitle}</span>
        </span>
      </button>
      {hasDetails ? (
        <div className="navbar-kitchen-badge__panel" role="status">
          {message ? <p className="navbar-kitchen-badge__message">{message}</p> : null}
          {reopenHint ? <p className="navbar-kitchen-badge__hint">{reopenHint}</p> : null}
        </div>
      ) : null}
    </div>
  );
}
